import { createSelector } from 'reselect'
import { IRootReducer } from '../reducers'
export const projectsSelectorState = (state: IRootReducer) => (state.projects)
export const isLoggedInSelectorState = (state: IRootReducer) => ({ user: state.user.isLoggedIn })

const userSelectorState = (state: IRootReducer) => ({ user: state.user })
export const loggedInSelector = createSelector(userSelectorState, ({ user }) => user.isLoggedIn)
export const projectsSelector = createSelector(projectsSelectorState, (projects) => projects)